import administrationEn from './locales/en/administration.json';
import authEn from './locales/en/auth.json';
import clinicalStudyEn from './locales/en/clinical-study.json';
import archiveEn from './locales/en/archive.json';
import communicationsEn from './locales/en/communications.json';
import closingEn from './locales/en/closing.json';
import commonEn from './locales/en/common.json';
import consentEn from './locales/en/consent.json';
import expensesEn from './locales/en/expenses.json';
import expensesListEn from './locales/en/expenses-list.json';
import expensesReportsEn from './locales/en/expenses-reports.json';
import expensesParityEn from './locales/en/expenses-parity.json';
import expensesDetailEn from './locales/en/expenses-detail.json';
import errorsEn from './locales/en/errors.json';
import financeEn from './locales/en/finance.json';
import identityDocumentsEn from './locales/en/identity-documents.json';
import toolsEn from './locales/en/tools.json';
import profileEn from './locales/en/profile.json';
import shellEn from './locales/en/shell.json';
import suppliersEn from './locales/en/suppliers.json';
import administrationIt from './locales/it/administration.json';
import authIt from './locales/it/auth.json';
import clinicalStudyIt from './locales/it/clinical-study.json';
import archiveIt from './locales/it/archive.json';
import communicationsIt from './locales/it/communications.json';
import closingIt from './locales/it/closing.json';
import commonIt from './locales/it/common.json';
import consentIt from './locales/it/consent.json';
import expensesIt from './locales/it/expenses.json';
import expensesListIt from './locales/it/expenses-list.json';
import expensesReportsIt from './locales/it/expenses-reports.json';
import expensesParityIt from './locales/it/expenses-parity.json';
import expensesDetailIt from './locales/it/expenses-detail.json';
import errorsIt from './locales/it/errors.json';
import financeIt from './locales/it/finance.json';
import identityDocumentsIt from './locales/it/identity-documents.json';
import toolsIt from './locales/it/tools.json';
import profileIt from './locales/it/profile.json';
import shellIt from './locales/it/shell.json';
import suppliersIt from './locales/it/suppliers.json';

/** The eight per-feature namespaces populated across Activities 7-9 and SL-0030 (Task 7.2), plus
 * `clinical-study` (SL-0041). */
export const NS = [
  'common',
  'shell',
  'administration',
  'profile',
  'identity-documents',
  'tools',
  'auth',
  'clinical-study',
  'finance',
  'expenses',
  'expenses-list',
  'expenses-reports',
  'expenses-parity',
  'expenses-detail',
  'closing',
  'communications',
  'archive',
  'errors',
  'consent',
  'suppliers',
] as const;

export const defaultNS = 'common' as const;

export const resources = {
  it: {
    common: commonIt,
    shell: shellIt,
    administration: administrationIt,
    profile: profileIt,
    'identity-documents': identityDocumentsIt,
    tools: toolsIt,
    auth: authIt,
    'clinical-study': clinicalStudyIt,
    finance: financeIt,
    expenses: expensesIt,
    'expenses-list': expensesListIt,
    'expenses-reports': expensesReportsIt,
    'expenses-parity': expensesParityIt,
    'expenses-detail': expensesDetailIt,
    closing: closingIt,
    communications: communicationsIt,
    archive: archiveIt,
    errors: errorsIt,
    consent: consentIt,
    suppliers: suppliersIt,
  },
  en: {
    common: commonEn,
    shell: shellEn,
    administration: administrationEn,
    profile: profileEn,
    'identity-documents': identityDocumentsEn,
    tools: toolsEn,
    auth: authEn,
    'clinical-study': clinicalStudyEn,
    finance: financeEn,
    expenses: expensesEn,
    'expenses-list': expensesListEn,
    'expenses-reports': expensesReportsEn,
    'expenses-parity': expensesParityEn,
    'expenses-detail': expensesDetailEn,
    closing: closingEn,
    communications: communicationsEn,
    archive: archiveEn,
    errors: errorsEn,
    consent: consentEn,
    suppliers: suppliersEn,
  },
} as const;
